import { Cap, Demo, DsSection } from '../primitives'

const SCALE: { px: number; role: string }[] = [
  { px: 4, role: 'Micro' },
  { px: 8, role: 'Micro' },
  { px: 16, role: 'Component' },
  { px: 24, role: 'Component' },
  { px: 32, role: 'Component' },
  { px: 40, role: 'Layout' },
  { px: 48, role: 'Layout' },
  { px: 64, role: 'Section' },
  { px: 80, role: 'Section' },
  { px: 96, role: 'Section' },
  { px: 128, role: 'Section' },
]

const RADII = [
  { cls: 'rounded-sm', label: '2px', use: 'buttons · cards · banners' },
  { cls: 'rounded-xl', label: '8px', use: 'chrome / overlays' },
  { cls: 'rounded-full', label: 'pill', use: 'pills' },
]

export function SpacingSection() {
  return (
    <DsSection id="spacing" title="Spacing & radius" marketing>
      <Demo label="Spacing scale — 8px base · 4px half-step">
        <div className="grid gap-2.5">
          {SCALE.map(({ px, role }) => (
            <div key={px} className="flex items-center gap-3.5">
              <span className="text-ink-500 w-10 font-mono text-[11px]">{px}</span>
              <div className="bg-brand-500 h-3.5 rounded-[2px]" style={{ width: px }} />
              <Cap>{role}</Cap>
            </div>
          ))}
        </div>
      </Demo>
      <Demo label="Radius system — tight & functional">
        <div className="flex items-end gap-5">
          {RADII.map(({ cls, label, use }) => (
            <div key={label} className="text-center">
              <div className={`border-ink-200 bg-ink-50 h-14 w-19 border ${cls}`} />
              <Cap className="mt-2">{label}</Cap>
              <div className="text-ink-500 mt-0.5 text-[11px]">{use}</div>
            </div>
          ))}
        </div>
      </Demo>
      <Demo label="Spacing in use — component padding 32 · heading→body gap 24 · icon→label 8">
        <div className="border-ink-100 max-w-md rounded-xl border p-8">
          <div className="text-brand-800 flex items-center gap-2">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 6 9 17l-5-5" />
            </svg>
            <Cap className="text-ink-500">padding 32 · gap 8</Cap>
          </div>
          <h4 className="text-ink my-6 text-2xl font-bold tracking-[-0.01em]">Aligned to one grid</h4>
          <p className="text-md text-ink-500 leading-relaxed">
            Every gap here is a scale step, so this card lines up with any neighbor built the same way.
          </p>
        </div>
      </Demo>
    </DsSection>
  )
}
